import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { ApolloError, useMutation } from '@apollo/client';
import { App } from 'antd';
import { directories } from '../../../graphql/mutations/mutations';
import { DirectoryInput, CreateDirectoryResponse } from '../../../types/directory';
import DirectoryForm from '../../../components/Directory/DirectoryForm';
import FormLayout from '../../../layouts/CardLayout';

const DirectoryCreate: React.FC = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const [createDirectory, { loading }] = useMutation<
    CreateDirectoryResponse,
    { input: DirectoryInput }
  >(directories.CREATE_DIRECTORY);

  const handleSubmit = async (values: DirectoryInput) => {
    try {
      const { data } = await createDirectory({
        variables: { input: values },
      });

      if (data?.createDirectory) {
        message.success('Directory successfully created');
        navigate(`/admin/directory/${data.createDirectory.id}`);
      }
    } catch (err: unknown) {
      if ((err as ApolloError).graphQLErrors?.length > 0) {
        const graphQLError = (err as ApolloError).graphQLErrors[0];
        setError(
          graphQLError.message.includes('slug')
            ? 'Slug has already been taken.'
            : graphQLError.message
        );
      } else {
        setError('An unexpected error occurred');
      }
    }
  };

  return (
    <FormLayout>
      <DirectoryForm
        onSubmit={handleSubmit}
        error={error}
        loading={loading}
        submitButtonText="Create"
      />
    </FormLayout>
  );
};

export default DirectoryCreate;
